var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldSmsEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 3C4 3 2 4.5 2 8v7c0 3.5 2 5 5 5h3.57c.59 0 1.07-.52.99-1.11-.1-.71-.08-1.45.07-2.21.53-2.6 2.67-4.67 5.29-5.1a6.51 6.51 0 0 1 3.66.45c.67.29 1.42-.17 1.42-.9V8c0-3.5-2-5-5-5H7zm7.34 8.09c-.66.53-1.5.79-2.34.79-.84 0-1.69-.26-2.34-.79l-3.13-2.5a.768.768 0 0 1-.12-1.06c.26-.32.73-.38 1.05-.12l3.13 2.5c.76.61 2.05.61 2.81 0l3.13-2.5c.32-.26.8-.21 1.05.12.26.33.21.8-.11 1.06l-3.13 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 18c0 2.76 2.24 5 5 5 2.77 0 5-2.24 5-5 0-2.77-2.23-5-5-5-2.76 0-5 2.23-5 5zm6.68-.09L17.5 20.1c-.1.09-.29.19-.43.21l-.98.14c-.35.05-.6-.2-.55-.55l.14-.98a.87.87 0 0 1 .21-.43l2.18-2.17.36-.37c.24-.24.51-.4.79-.4.24 0 .51.11.81.4.67.65.46 1.16.02 1.6l-.37.36z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldSmsEdit);
export default __webpack_public_path__ + "static/media/vuesax-bold-sms-edit.021e66da1e862fd61fe5d80b86c8fd6a.svg";
export { ForwardRef as ReactComponent };